import { Stack } from '@mui/material'

import { ContentFrame } from '@/components/layouts/ContentFrame'
import {
  PaymentCreateForm,
  PaymentCreateFormProps,
} from '@/components/pages/PaymentCreate/template/PaymentCreateForm'
import { useTranslation } from '@/core'
import { Organism, OrganismFrame } from '@/core/architecture'

import { Header } from './Header'

export type BuyNowPaymentCreateProps = {
  onCreatePayment: PaymentCreateFormProps['onSubmitCreatePayment']
  onClose: () => void
}

export const BuyNowPaymentCreate: Organism<BuyNowPaymentCreateProps> = ({
  onCreatePayment,
  onClose,
}) => {
  const { t } = useTranslation('storeItemDetail')
  return (
    <OrganismFrame>
      <Header
        back
        title={t('paymentCreateTitle', '支払い方法')}
        onClose={onClose}
      />
      <ContentFrame>
        <Stack sx={{ px: 5, pt: 4 }}>
          <PaymentCreateForm onSubmitCreatePayment={onCreatePayment} />
        </Stack>
      </ContentFrame>
    </OrganismFrame>
  )
}
